import { AGUARDANDO_COMPARECIMENTO, NAO_COMPARECEU_AGENDAMENTO } from '../common/constants/etapasPericia';
import { CODIGO_DEFERIDO, CODIGO_DESISTIDO, CODIGO_INDEFERIDO, CODIGO_RESTABELECIDO, CODIGO_AGUARDANDO_PERICIA } from '../common/constants/situacoesSibe';
import { dataStringToIso, formatToBrDate, adicionarDiasComResultadoFormatadoBrDate } from "../helper";
import { EXIGENCIA, PENDENTE } from '../common/constants/statusTarefa';
import { obterCampoAdicionalPorSiglaIgnoreCase, obterCampoAdicionalPorNomeIgnoreCase } from "../disponibilidade/helper";
import { obterSiglaTipoPericiaPMF } from "../pericia/helper";
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import DateUtil from "../disponibilidade/DateUtil"

import { 
  SIGLA_CAMPO_BI_MIGRADO_SABI, 
  SIGLA_CAMPO_DATA_EMISSAO_ATESTADO, 
  SIGLA_CAMPO_DATA_INICIO_DOENCA, 
  SIGLA_CAMPO_FLUXO_BI, 
  SIGLA_CAMPO_INFORMA_DATA_INICIO_REPOUSO 
} from '../common/constants/siglasCamposAdicionais';

import {
  SIGLA_CAMPO_ADICIONAL_ATESTADO_MEDICO,
  SIGLA_CAMPO_ADICIONAL_NUMERO_BENEFICIO,
  SIGLA_CAMPO_ADICIONAL_NUMERO_BENEFICIO_RESTABELECIDO,
  SIGLA_CAMPO_ADICIONAL_UNIDADE_MANUTENCAO,
  isServicoConcessaoBeneficioIncapacidade,
  SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO,
  SIGLA_CAMPO_ADICIONAL_DATA_CESSACAO_BENEFICIO,
  SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO,
  SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE,
  SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE,
  SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA,
  isServicoProrrogacaoBeneficioIncapacidade,
  SIGLA_SERVICO_AGENDAMENTO_PERICIA_PMC,
  SIGLA_SERVICO_AGENDAMENTO_PERICIA_PMRES
} from "../selecaoServicos/siglaServico";

export async function trataStatusTarefa(tarefa, permissaoRealizarAnaliseDocumental) {
  let statusDescricao = tarefa?.status
  let mensagem = ''
  let severidade = 'info'

  if (tarefa?.status === 'CANCELADA') {
    statusDescricao = 'CANCELADO'
    severidade = 'error'
    mensagem = 'Pedido cancelado'
  }

  if (tarefa?.status === 'CONCLUIDA') {
    statusDescricao = 'CONCLUIDO'
    severidade = 'success'
    let numeroBeneficio = obterNumeroBeneficio(tarefa);
    let numeroBeneficioRestabelecido = obterNumeroBeneficioRestabelecido(tarefa);
    if (tarefa?.tarefaOrigem) {
      mensagem = `O benefício ${numeroBeneficio ?? ''} foi aprovado após análise do pedido ${tarefa.tarefaOrigem?.numeroProtocolo}. Detalhe o pedido e verifique os despachos e comentários.`
    } else if (Array.isArray(tarefa?.tarefasDerivadas) && tarefa.tarefasDerivadas[0]) {
      mensagem = `Benefício aprovado. Após análise da perícia foi gerado um novo pedido. Consulte o pedido ${tarefa.tarefasDerivadas[0].numeroProtocolo} e saiba mais.`
    } else if (isSituacaoSibeRestabelecido(tarefa) && numeroBeneficioRestabelecido) {
      mensagem = `Após análise da perícia foi restabelecido o benefício ${numeroBeneficioRestabelecido}.`
    } else {
      mensagem = 'Pedido concluído'
    }
  }

  if (tarefa?.status === 'CUMPRIMENTO_DE_EXIGENCIA') {
    statusDescricao = 'EXIGÊNCIA'
    severidade = 'warning'
    mensagem = obterMensagemPorTipoExigencia(tarefa);
  }

  if (tarefa?.status === 'PENDENTE') {
    statusDescricao = 'EM ANÁLISE'
    mensagem = 'Pedido em análise'
    severidade = 'warning'
    const podeRealizarAnaliseDocumental = permissaoRealizarAnaliseDocumental
    if (podeRealizarAnaliseDocumental) {
      mensagem = `É possível alterar a perícia presencial em análise documental. Faça o pedido selecionando “Análise Documental”.`
    } else if (tarefa?.tarefaOrigem) {
      mensagem = `Aguarde o resultado da análise. Pedido automático e gerado a partir do pedido ${tarefa.tarefaOrigem.numeroProtocolo}.`
    }
  }


  return { situacao: statusDescricao, mensagem, severidade }
}

export const obterMensagemPorTipoExigencia = (tarefa) => {
  const { tipoExigencia, dataPrazo, dataExigencia } = tarefa;
  const prazoFormatado = formatToBrDate(dataPrazo);
  const QUANTIDADE_DIAS_A_PARTIR_DATA_EXIGENCIA_PARA_PENDENCIA_FALTA_ATESTADO_MEDICO = 5;
  const dataExigenciaFormatada = adicionarDiasComResultadoFormatadoBrDate(dataExigencia, QUANTIDADE_DIAS_A_PARTIR_DATA_EXIGENCIA_PARA_PENDENCIA_FALTA_ATESTADO_MEDICO)
  let mensagem = `Faltam documentos ou informações. Adicione até ${prazoFormatado} pelo Meu INSS.`
  if (tipoExigencia === 'FALTA_AGENDAMENTO') {
    mensagem = `Agende sua perícia médica até ${prazoFormatado} para continuar com o pedido.`;
  } else if (tipoExigencia === 'FALTA_ATESTADO') {
    mensagem = `Falta documento médico (atestado/ laudo). Adicione até ${dataExigenciaFormatada} pelo Meu INSS.`;
  } else if (tipoExigencia === 'CIENCIA') {
    mensagem = `Seu pedido teve alterações importantes. Confirme que encontra-se ciente para que seu pedido tenha andamento.`;
  }
  return mensagem;
}

export function trataStatusAgendamento(situacaoAgendamento) {
  let status = situacaoAgendamento;
  let icon = 'fas fa-calendar';
  let iconColor = 'fa-calendar';
  let backgroundColor = '#155bcb'
  let severity = 'info';

  if (situacaoAgendamento === 'AGENDADO' || situacaoAgendamento === 'AGENDADO_IMPACTADO') {
    status = 'Agendado'
    icon = 'fas fa-calendar-alt'
    iconColor = '#2680EB'
    backgroundColor = '#D4E5FF'
    severity = 'info'
  }

  if (status === 'CUMPRIDO' || status === 'CONCLUIDA' || status === 'CUMPRIDO_IMPACTADO') {
    status = 'Cumprido'
    icon = 'fas fas fa-calendar-check'
    iconColor = '#2680EB'
    backgroundColor = '#D4E5FF'
    severity = 'info'
  }

  if (situacaoAgendamento === 'REMARCADO' || situacaoAgendamento === 'REMARCADO_IMPACTADO') {
    status = 'Remarcado'
    icon = 'fas fa-calendar-minus'
    iconColor = '#3D4551'
    backgroundColor = '#DFE1E2'
    severity = 'info'
  }

  if (situacaoAgendamento === 'CANCELADO' || situacaoAgendamento === 'CANCELADA' || situacaoAgendamento === 'CANCELADO_IMPACTADO') {
    status = 'Cancelado'
    icon = 'fas fa-calendar-times'
    iconColor = '#3D4551'
    backgroundColor = '#DFE1E2'
    severity = 'error'
  }

  if (situacaoAgendamento === 'PENDENTE' || situacaoAgendamento === 'CUMPRIMENTO_DE_EXIGENCIA') {
    status = 'Pendente'
    icon = 'fas fa-exclamation-triangle'
    iconColor = '#FFF333'
    severity = 'warning';
  }

  return { status, severity, icon, iconColor, backgroundColor }
}

export function isAnaliseOuCumprimentoExigencia(tarefa) {
  return tarefa?.status === 'PENDENTE' ||
    tarefa?.status === 'CUMPRIMENTO_DE_EXIGENCIA';
}

export function isExigenciaFaltaAgendamento(tarefa) {
  if (!tarefa?.tipoExigencia) return false;
  return tarefa?.status === 'CUMPRIMENTO_DE_EXIGENCIA' &&
    tarefa?.tipoExigencia === 'FALTA_AGENDAMENTO';
}

export function isExigenciaFaltaAgendamentoEPericia(tarefa) {
  if (!tarefa?.tipoExigencia) return false;
  return tarefa?.status === 'CUMPRIMENTO_DE_EXIGENCIA' &&
    tarefa?.tipoExigencia === 'FALTA_AGENDAMENTO_AVS_PERICIA';
}

export function isExigenciaFaltaAtestado(tarefa) {
  if (!tarefa?.tipoExigencia) return false;
  return tarefa?.status === 'CUMPRIMENTO_DE_EXIGENCIA' &&
    tarefa?.tipoExigencia === 'FALTA_ATESTADO';
}

export function isExigenciaCiencia(tarefa) {
  if (!tarefa?.tipoExigencia) return false;
  return tarefa?.status === 'CUMPRIMENTO_DE_EXIGENCIA' &&
    tarefa?.tipoExigencia === 'CIENCIA';
}

export function isPericiaComSituacaoAgendadaParaDataFutura(agendamento) {
  if (!agendamento.situacaoAgendamento || !agendamento.dataAgendamento) return false;
  return agendamento?.situacaoAgendamento === 'AGENDADO'
    && DateUtil.diff(agendamento?.dataAgendamento, new Date()) >= 0;
}

export function isExisteAgendamentoPericiaFuturo(agendamentos) {
  if (agendamentos?.filter(isPericiaComSituacaoAgendadaParaDataFutura)?.length > 0) {
    return true;
  } else {
    return false;
  }
}

export const podeCumprirExigenciaFaltaAgendamentoPericiaParaPPBI = (camposAdicionais, siglaServico, agendamentos) => {
  if (isServicoProrrogacaoBeneficioIncapacidade(siglaServico)) {
    const campoTipoPP = obterCampoAdicionalPorSiglaIgnoreCase(
      camposAdicionais,
      SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO
    );

    const campoSituacaoPrimeiroAgendamento = obterCampoAdicionalPorSiglaIgnoreCase(
      camposAdicionais,
      SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA
    );

    const valorCampoTipoPP = campoTipoPP.conteudo ?? campoTipoPP.valorCampoAdicional;
    const valorCampoSituacaoPrimeiroAgendamento =
      campoSituacaoPrimeiroAgendamento.conteudo ??
      campoSituacaoPrimeiroAgendamento.valorCampoAdicional;

    if ((!valorCampoTipoPP || valorCampoTipoPP == 'PMAN') &&
      valorCampoSituacaoPrimeiroAgendamento &&
      ['SEM_NECESSIDADE_AGENDAMENTO', 'VAGA_DISTANTE'].includes(valorCampoSituacaoPrimeiroAgendamento)) {
      return true;
    } else {
      const siglasServicoPericiaPP = [SIGLA_SERVICO_AGENDAMENTO_PERICIA_PMC, SIGLA_SERVICO_AGENDAMENTO_PERICIA_PMRES];
      // Limita a possibilidade de cumprimento de exigência a existência de agendamento REALIZADO na PMF para PPBI
      return agendamentos.filter(a => siglasServicoPericiaPP.includes(a.siglaServico))
        .some(a => a.situacaoAgendamento == 'AGENDADO');
    }
  }

  return true;
}

export const isCampoAdicionalAtestadoMedico = campoAdicional => {
  return campoAdicional.sigla === SIGLA_CAMPO_ADICIONAL_ATESTADO_MEDICO;
}

export const isCampoAdicionalNumeroBeneficio = campoAdicional => {
  return campoAdicional.nome === SIGLA_CAMPO_ADICIONAL_NUMERO_BENEFICIO;
}

export const isCampoAdicionalNumeroBeneficioRestabelecido = campoAdicional => {
  return campoAdicional.sigla === SIGLA_CAMPO_ADICIONAL_NUMERO_BENEFICIO_RESTABELECIDO;
}

export const isCampoAdicionalUnidadeManutencao = campoAdicional => {
  return campoAdicional.sigla === SIGLA_CAMPO_ADICIONAL_UNIDADE_MANUTENCAO;
}

export const isCampoAdicionalDataEmissaoAtestado = campoAdicional => {
  return campoAdicional.sigla === SIGLA_CAMPO_DATA_EMISSAO_ATESTADO;
}

export const isCampoAdicionalInformaDataInicioRepouso = campoAdicional => {
  return campoAdicional.sigla === SIGLA_CAMPO_INFORMA_DATA_INICIO_REPOUSO;
}

export const isCampoAdicionalDataInicioRepouso = campoAdicional => {
  return campoAdicional.sigla === SIGLA_CAMPO_DATA_INICIO_DOENCA;
}

export const obterNumeroBeneficio = tarefa => {
  if (tarefa?.camposAdicionais) {
    let campoNumeroBeneficio = tarefa.camposAdicionais.find(isCampoAdicionalNumeroBeneficio);
    return campoNumeroBeneficio?.conteudo;
  } else {
    return null;
  }
}

export const obterNumeroBeneficioRequerimento = requerimento => {
  if (requerimento.hasOwnProperty('dadosAdicionais') && requerimento?.dadosAdicionais && requerimento?.dadosAdicionais !== null ) {
    let campo = obterCampoAdicionalPorNomeIgnoreCase(
      requerimento?.dadosAdicionais,
      SIGLA_CAMPO_ADICIONAL_NUMERO_BENEFICIO);
    return campo?.valor;
  } else {
    return null;
  }
}

export const obterSiglaTipoPericiaProrrogacaoParaPMF = tarefa => {

  let campoTipoPericiaProrrogacao = obterCampoAdicionalPorSiglaIgnoreCase(
    tarefa?.camposAdicionais, SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO);

  return campoTipoPericiaProrrogacao?.conteudo ?
    obterSiglaTipoPericiaPMF(campoTipoPericiaProrrogacao?.conteudo) :
    'INSS_PMANPMF';
}

export const obterDataCessacaoBeneficio = tarefa => {

  let campoDCB = obterCampoAdicionalPorSiglaIgnoreCase(
    tarefa?.camposAdicionais, SIGLA_CAMPO_ADICIONAL_DATA_CESSACAO_BENEFICIO);

  return campoDCB ? dataStringToIso(campoDCB?.conteudo) : null;
}

export const isPossuiNumeroBeneficio = tarefa => !isNil(obterNumeroBeneficio(tarefa));
export const isTarefaOrigem = tarefa => !isEmpty(tarefa?.tarefasDerivadas);
export const isSituacaoSibeRestabelecido = tarefa => tarefa?.situacaoSibe === CODIGO_RESTABELECIDO;
export const isSituacaoSibeDeferidoOuIndeferido = tarefa => tarefa?.situacaoSibe === CODIGO_DEFERIDO || tarefa?.situacaoSibe === CODIGO_INDEFERIDO;
export const isSituacaoSibeDesistido = tarefa => tarefa?.situacaoSibe === CODIGO_DESISTIDO;
export const isSituacaoSibeAguardandoPericia = tarefa => tarefa?.situacaoSibe == CODIGO_AGUARDANDO_PERICIA;

export const isExibeConsultarBeneficioOrigem = tarefa => {
  const tarefaComTransformacao = isTarefaOrigem(tarefa) && isPossuiNumeroBeneficio(tarefa);
  const tarefaComSituacaoSibeRestabelecido = isSituacaoSibeRestabelecido(tarefa);
  return tarefaComTransformacao || tarefaComSituacaoSibeRestabelecido;
}

export const obterNumeroBeneficioRestabelecido = tarefa => {
  if (tarefa?.camposAdicionais) {
    let campoNBRestabelecido = tarefa.camposAdicionais.find(isCampoAdicionalNumeroBeneficioRestabelecido);
    return campoNBRestabelecido?.conteudo;
  } else {
    return null;
  }
}

export const obterUnidadeManutencao = tarefa => {
  if (tarefa?.camposAdicionais) {
    let campoidUOMantenedora = tarefa.camposAdicionais.find(isCampoAdicionalUnidadeManutencao);
    return campoidUOMantenedora?.conteudo;
  } else {
    return null;
  }
}

export const obterUnidadeManutencaoRequerimento = requerimento => {
  if (requerimento?.dadosAdicionais) {
    let campoAPSMANUT = obterCampoAdicionalPorSiglaIgnoreCase(
      requerimento?.dadosAdicionais,
      SIGLA_CAMPO_ADICIONAL_UNIDADE_MANUTENCAO);
    return campoAPSMANUT?.valor;
  } else {
    return null;
  }
}

export const obterTarefaDerivada = tarefa => {
  if (Array.isArray(tarefa?.tarefasDerivadas)) {
    let tarefasBI = tarefa.tarefasDerivadas.filter(tarefaDerivada =>
      isServicoConcessaoBeneficioIncapacidade(tarefaDerivada?.servico?.sigla));
    return tarefasBI && tarefasBI[0];
  } else {
    return null;
  }
}

export const gerarListaDeCamposExigenciaAposAlteracaoDoCampo = (campoModificado, listaAtual) => {
  let listaModificada = [].concat(listaAtual);
  if (campoModificado) {
    listaModificada = listaAtual.map((campo) => {
      if (campo.id === campoModificado.id) {
        return {
          ...campoModificado,
        };
      }
      let visibilidadeCampo = obterVisibilidadeDoCampoExigencia(campo, campoModificado);
      return {
        ...campo,
        visivel: visibilidadeCampo,
        valor: visibilidadeCampo ? campo.valor : "",
        valorComMascara: visibilidadeCampo ? campo.valorComMascara : "",
      };
    });
  }
  return listaModificada;
}

function obterVisibilidadeDoCampoExigencia(campoExigencia, campoModificado) {
  if (campoModificado?.valorComMascara && campoModificado?.comboboxAssociados &&
    Array.isArray(campoExigencia?.idsCamposAdicionaisPais) &&
    campoExigencia?.idsCamposAdicionaisPais.includes(campoModificado.id)) {
    return isCampoAssociadoAtual(campoModificado, campoExigencia.id);
  } else {
    return campoExigencia.visivel;
  }
}

function isCampoAssociadoAtual(outroCampo, idCampoAdicional) {
  return outroCampo && outroCampo.valorComMascara && outroCampo.comboboxAssociados &&
    Object.entries(outroCampo.comboboxAssociados)?.length > 0 &&
    outroCampo.comboboxAssociados[outroCampo.valorComMascara] === idCampoAdicional;
}

export const isExibeBaixarLaudoPericia = (tarefa) =>
  tarefa?.servico?.sigla !== SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO &&
  (tarefa?.status === 'CANCELADA' || tarefa?.status === 'CONCLUIDA');

export const isExibeHistoricoAgendamento = (tarefa, agendamentos) =>
  tarefa?.servico?.sigla !== SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO &&
  tarefa?.etapaPericia &&
  checkPossuiAgendamentoDaTarefa(tarefa, agendamentos);

const checkPossuiAgendamentoDaTarefa = (tarefa, agendamentos) =>
  agendamentos?.find((agendamento) => agendamento?.protocoloINSS == tarefa?.numeroProtocolo);

export const isExibeResultadoBeneficioIncapacidade = (tarefa) =>
  tarefa?.podeExibirBotaoDownloadCrer;

export const isExibeAgendamentoPericiaParaReagendar = (
  tarefa,
  agendamentoParaRemarcar
) => checkTarefaPermiteReagendar(tarefa) && agendamentoParaRemarcar;

const checkTarefaPermiteReagendar = (tarefa) =>
  (tarefa?.servico?.sigla === SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE || tarefa?.servico?.sigla === SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE) &&
  (tarefa?.status === PENDENTE || tarefa?.status === EXIGENCIA) &&
  (tarefa?.etapaPericia === AGUARDANDO_COMPARECIMENTO || tarefa?.etapaPericia === NAO_COMPARECEU_AGENDAMENTO);

const dataAgendamentoDecrescenteSort = (a, b) => new Date(b.dataHoraAgendamento) - new Date(a.dataHoraAgendamento);

const filtrarUltimoAgendamentoParaReagendar = (agendamentos, situacaoAgendamento) => {
  return agendamentos
    .filter((agendamento) => agendamento.remarcarHabilitado)
    .sort(dataAgendamentoDecrescenteSort)
    .find((agendamento) => agendamento.situacaoAgendamento === situacaoAgendamento);
}

export const obterUltimoAgendamentoParaReagendar = (tarefa, agendamentos) => {
  if (checkTarefaPermiteReagendar(tarefa) && !isEmpty(agendamentos)) {
    if (tarefa?.etapaPericia === AGUARDANDO_COMPARECIMENTO) {
      return filtrarUltimoAgendamentoParaReagendar(agendamentos, "AGENDADO");
    } else if (tarefa?.etapaPericia === NAO_COMPARECEU_AGENDAMENTO) {
      return filtrarUltimoAgendamentoParaReagendar(agendamentos, "CUMPRIDO");
    }
  }
  return null;
}

export const isRequerimentoMigradoSabi = (tarefa) => {
  let campoMigradoSabi = obterCampoAdicionalPorSiglaIgnoreCase(
    tarefa?.camposAdicionais, SIGLA_CAMPO_BI_MIGRADO_SABI);
  return campoMigradoSabi?.conteudo?.toUpperCase() === 'SIM';
}

export const isFluxoPresencialBI = (tarefa) => {
  let campoFluxoBI = obterCampoAdicionalPorSiglaIgnoreCase(
    tarefa?.camposAdicionais, SIGLA_CAMPO_FLUXO_BI);
  return campoFluxoBI?.conteudo?.toUpperCase() === 'PRESENCIAL';
}

export const isEtapaPericiaDiferenteConcluidaOuCanceladaPorNaoComparecimento = (tarefa) => {
  return tarefa?.etapaPericia?.toUpperCase() !== 'CONCLUIDO' &&
    tarefa?.etapaPericia?.toUpperCase() !== 'CANCELADA_POR_NAO_COMPARECIMENTO' &&
    tarefa?.etapaPericia?.toUpperCase() !== 'EM_EXIGENCIA_SIMA';
}